import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MatIconButton } from '@angular/material/button'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatIcon } from '@angular/material/icon'
import {
  ElderHeaderComponent,
  ElderThemeDirective,
  ElderToolbarColumnDirective,
  ElderToolbarComponent,
  ElderToolbarService,
  ElderToolbarTitleService,
} from '@elderbyte/ngx-starter'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { PackagingMaterialSpec } from '../../../package-type'
import { PackageTypeMaterialDetailComponent } from '../package-type-material-detail/package-type-material-detail.component'

export interface PackageTypeMaterialDialogData {
  materialSpec: PackagingMaterialSpec
}

@Component({
  selector: 'app-package-type-material-detail-dialog',
  imports: [
    MatIcon,
    MatIconButton,
    ElderTranslatePipe,
    FormsModule,
    ElderHeaderComponent,
    ElderToolbarComponent,
    ElderToolbarColumnDirective,
    ElderThemeDirective,
    PackageTypeMaterialDetailComponent,
  ],
  template: `
    <div class="layout-col full">
      <elder-toolbar elderTheme>
        <ng-template elderToolbarColumn="left">
          <button mat-icon-button (click)="close()">
            <mat-icon>close</mat-icon>
          </button>

          <elder-header
            [header]="'packages.packagingMaterial' | translate"
            [subheader]="materialSpec.materialId ?? 'context.new' | translate"
          >
          </elder-header>
        </ng-template>
        <ng-template elderToolbarColumn="right.actions">
          <button mat-icon-button [disabled]="!form.form.valid" (click)="save($event)">
            <mat-icon>save</mat-icon>
          </button>
        </ng-template>

        <ng-template elderToolbarColumn="right" [elderToolbarDefault]="true">
          <!-- Clear language switcher -->
        </ng-template>
      </elder-toolbar>

      <form #form="ngForm">
        <app-package-type-material-detail
          [materialSpec]="materialSpec"
        ></app-package-type-material-detail>
      </form>
    </div>
  `,
  providers: [ElderToolbarService, ElderToolbarTitleService],
})
export class PackageTypeMaterialDetailDialogComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly dialogRef =
    inject<MatDialogRef<PackageTypeMaterialDetailDialogComponent>>(MatDialogRef)
  readonly materialSpec: PackagingMaterialSpec

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const data = inject<PackageTypeMaterialDialogData>(MAT_DIALOG_DATA)
    const original = data.materialSpec
    this.materialSpec = new PackagingMaterialSpec(original?.materialId, original?.presetQuantity)
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public save(_: Event): void {
    this.close(this.materialSpec)
  }

  public close(spec?: PackagingMaterialSpec): void {
    this.dialogRef.close(spec)
  }
}
